// categories for keyboard shortcuts

const categories = [
  {
    name: 'All',
    color: ''
  },
  {
    name: 'General',
    color: '#b9a7ff'
  },
  {
    name: 'Toolbar',
    color: '#88cefa'
  },
  {
    name: 'Drawing',
    color: 'khaki'
  },
  {
    name: 'Navigate',
    color: '#ffbfcb'
  },
  {
    name: 'Edit',
    color: '#ee82ee'
  },
  {
    name: 'Select',
    color: '#fa7e73'
  },
  {
    name: 'Filter',
    color: '#ddb887'
  },
  {
    name: 'Connect',
    color: '#65cdaa'
  },
  {
    name: 'Search',
    color: '#8fbb8f'
  }

]

export default categories
